<template>
  <div class="search-input">
    <Multiselect id="ajax"
                track-by="id"
                label="desc"
                placeholder="Type to search"
                :value="resultsLocations"
                :options="results"
                :multiple="true"
                :searchable="true"
                :loading="isLoading"
                :internal-search="false"
                :clear-on-select="false"
                :close-on-select="false"
                :options-limit="300"
                :limit="3"
                :limit-text="limitText"
                @search-change="search"
                @select="addSelectedLocationId"
                @remove="removeSelectedLocationId">
      <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
    </Multiselect>

    <div id="locations-submit" class="locations-submit" v-on:click="goTo" v-bind:class="[{'is-loading': isLoading}]">
        <!-- <div class="button button-default"> -->
        <!--     <input class="locations-submit-button" type="button" value="Reload"> -->
        <!--     <i class="material-icons">cached</i> -->
        <!-- </div> -->
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Multiselect from 'vue-multiselect'

export default {
  name: 'filterLocations',

  components: {
    Multiselect
  },

  data: function () {
    return {
      isLoading: false
    }
  },

  computed: {
    results () {
      return this.$store.getters['filterLocations/results']
    },

    resultsLocations () {
      return this.$store.getters['filterLocations/selectedLocations']
    },

    isLoading () {
      // return (this.$store.getters.collisionLocations.length > 0) ? 0 : 1
    }
  },

  watch: {
    $route: function (to, from) {
      if (this.$route.params.lids) {
        this.$store.dispatch('filterLocations/setSelectedLocations', this.$route.params.lids)
      }
    }
  },

  methods: {
    limitText (count) {
      return `and ${count} other locations`
    },

    search: _.debounce(function (formInput) {
      this.$store.dispatch('filterLocations/search', formInput)
    }),

    goTo () {
      this.$router.push({
        name: 'locations',
        params: {
          lids: this.$store.getters['filterLocations/selectedLocationIds'].toString()
        }
      })
    },

    addSelectedLocationId (selectedLocation) {
      this.$store.dispatch('filterLocations/addSelectedLocationId', selectedLocation.id)
    },

    removeSelectedLocationId (removedLocation) {
      this.$store.dispatch('filterLocations/removeSelectedLocationId', removedLocation.id)
    }
  }
}
</script>

<style lang="scss">
@import "../../node_modules/vue-multiselect/dist/vue-multiselect.min.css";
</style>



// WEBPACK FOOTER //
// FilterLocations.vue?74866846